(() => {
  const IDS = ['login', 'recover'];
  const $ = (id) => document.getElementById(id);

  const setActive = (id) => {
    IDS.forEach((name) => {
      const el = $(name);
      if (!el) return;
      const active = name === id;
      el.classList.toggle('active', active);
      el.toggleAttribute('hidden', !active); 
      el.setAttribute('aria-hidden', String(!active));
      if (active) {
        const target = el.querySelector('input:not([type=hidden]), button, a, select, textarea');
        target && target.focus({ preventScroll: true });
      }
    });
  };

  const init = () => {
    setActive(location.hash === '#recover' ? 'recover' : 'login');
  };

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href="#login"], a[href="#recover"]');
    if (!a) return;
    e.preventDefault();
    const id = a.getAttribute('href').slice(1);
    setActive(id);
    history.replaceState(null, '', `#${id}`);
  });

  window.addEventListener('hashchange', () => {
    const id = location.hash.replace('#', '');
    if (id === 'login' || id === 'recover') setActive(id);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
